<template>
  <div class="CalendarForm">
    <b-sidebar
      no-close-on-esc
      no-close-on-backdrop
      width="400px"
      shadow
      :visible="orderFormStatus.show"
      right
      backdrop-variant="primary"
      backdrop
    >
      <template #footer>
        <div class="p-1">
          <hr />
          <div class="row">
            <div class="col text-right">
              <b-button
                :variant="user.role === 'leader' ? 'default' : ''"
                class="mr-1"
                @click="closeStatusEdit()"
              >
                {{ user.role === "leader" ? "Cancelar" : "Fechar" }}
              </b-button>
              <b-button variant="primary" @click="save()" v-if="user.role === 'leader'">
                Salvar
              </b-button>
            </div>
          </div>
        </div>
      </template>
      <template #header>
        <div class="CalendarForm--header">
          <b-button
            size="sm"
            variant="default"
            class="btn-icon rounded-circle"
            @click="$emit('onClose')"
          >
            <feather-icon icon="XIcon" size="20" />
          </b-button>
          Editar Status
        </div>
      </template>

      <div v-if="orderFormStatus.show" class="px-2 pt-1">
        <div class="row">
          <div class="col-4">
            <b-form-group label="Código" label-for="code">
              <input
                id="code-service-order"
                v-model="orderService.code"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('code-service-order') }"
                name="code-service-order"
                type="text"
                class="form-control"
                disabled
              />
            </b-form-group>
          </div>
          <div class="col-8">
            <b-form-group
              label="Cliente"
              :class="{ 'is-invalid': errors.has('customer-service-order') }"
              label-for="customer-service-order"
            >
              <v-select
                id="customer-service-order"
                v-model="orderService.customer"
                v-validate="'required'"
                name="customer-service-order"
                label="name"
                disabled
                :reduce="customer => customer._id"
              />
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <b-card no-body class="m-0 CalendarFormTask-card">
              <!-- HEADER COLLAPSE -->
              <template #header>
                <div class="w-100 CalendarFormTask-card-header">
                  <div class="row">
                    <div class="col-12">
                      <div>
                        <h4
                          class="text-center m-0 CalendarFormTask-card-h4 not-selectable"
                          size="sm"
                          variant="default"
                          block
                        >
                          Tarefa {{ orderFormStatus.task.startDate | invertDate }}
                          {{
                            orderFormStatus.task.startTime
                              ? "às " + orderFormStatus.task.startTime
                              : ""
                          }}
                        </h4>
                      </div>
                    </div>
                    <div
                      v-if="!!orderFormStatus.task.status"
                      class="col-12 text-center not-selectable"
                    >
                      <small>Status atual: </small>
                      <b-badge
                        :variant="`${STATUS_TASKS_OBJ[orderFormStatus.task.status].color}`"
                        class="badge-glow CalendarFormTask-badge"
                      >
                        {{ STATUS_TASKS_OBJ[orderFormStatus.task.status].label }}
                      </b-badge>
                    </div>
                    <div class="col-12">
                      <br />
                      <b-form-group
                        label="Selecione o novo status abaixo:"
                        :class="{ 'is-invalid': errors.has(`service-status-edit`) }"
                        label-for="service"
                      >
                        <v-select
                          id="status"
                          v-model="task.status"
                          v-validate="'required'"
                          :name="`service-status-edit`"
                          label="label"
                          :reduce="status => status.value"
                          :options="getStatusByActualStatus"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </template>
            </b-card>
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { STATUS_TASKS_OBJ, STATUS_TASKS_ARRAY, task } from "@/constants/tasks";
import store from "@/store";

export default {
  data() {
    return {
      STATUS_TASKS_ARRAY,
      STATUS_TASKS_OBJ,
      orderService: {
        code: null,
        customer: null,
        tasks: [],
        tasksDelete: []
      },
      task: {
        status: null
      }
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("orders", ["orderFormStatus"]),
    isNew() {
      return !(this.orderFormStatus && !!this.orderFormStatus.serviceOrder);
    },
    getStatusByActualStatus() {
      let status = [];
      if (task.status == "WAITING") {
        status = ["WAITING", "IN_PROGRESS"];
      } else {
        status = ["IN_PROGRESS", "COMPLETED", "CANCELED", "IMPEDED"];
      }

      return STATUS_TASKS_ARRAY.filter(statusTask => status.includes(statusTask.value));
    }
  },
  watch: {
    isNew() {
      this.init();
    }
  },
  methods: {
    ...mapActions("orders", ["closeStatusEdit"]),
    init() {
      if (this.orderFormStatus && !!this.orderFormStatus.serviceOrder) {
        const { code, customer, tasks, _id } = this.orderFormStatus.serviceOrder;
        const serviceOrder = {
          _id,
          code,
          tasks,
          customer: customer
        };
        const task = {
          _id: this.orderFormStatus.task._id,
          status: this.orderFormStatus.task.status
        };

        Object.assign(this.orderService, serviceOrder);
        Object.assign(this.task, task);
      }
    },
    async save() {
      try {
        const validate = await this.$validator.validate();

        if (validate) {
          this.orderService.tasks = this.orderService.tasks.map(task => {
            if (task._id === this.task._id) {
              task.status = this.task.status;
            }
            return task;
          });

          await store.dispatch("orders/updateEvent", this.orderService);
          this.closeStatusEdit();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
